module.exports = __webpack_public_path__ + "static/media/bt.303ef8ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/bt.svg
// module id = 74
// module chunks = 0